var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var Tooltip_1 = __importDefault(require("./Tooltip"));
exports.Tooltip = Tooltip_1.default;
exports.default = Tooltip_1.default;
//# sourceMappingURL=index.js.map